import React from 'react';
import ProfileInterestChip from './ProfileInterestChip';
import '../../../assets/css/style.css';

const ProfileChipContainer = ({ interests, containerFit }) => {
    const chips = interests.map((interest) => { return <ProfileInterestChip key={interest} name={interest} /> });
    return (
        <div className="interest-container" style={containerFit}>
            {chips}
        </div>
    );
};

export default ProfileChipContainer;